import React from 'react';
import { Button } from '../components/ui/Button';
import { MessageCircle } from 'lucide-react';
export function ContactPage() {
  const handleWhatsApp = () => {
    window.open('https://wa.link/infocommerce', '_blank');
  };
  return <div className="min-h-screen w-full flex flex-col items-center justify-center bg-[#FAFAFA] px-4 py-8 sm:p-4" data-id="element-419" data-mp="sqsxnk4y5vs7">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-420" data-mp="xokm246duzrn">
        {/* Header Section */}
        <div className="p-6 sm:p-10 text-center space-y-6 sm:space-y-8" data-id="element-421" data-mp="505axsqdh1ll">
          <div className="space-y-3" data-id="element-422" data-mp="52i1gua74ka9">
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-423" data-mp="9zi75434vl0u">
              ¿Tienes Preguntas?
            </h1>
            <p className="text-gray-500 text-base sm:text-lg" data-id="element-424" data-mp="f0603vaxabxp">
              Estamos aquí para ayudarte a resolver cualquier duda sobre el
              programa.
            </p>
          </div>

          <div className="py-4 space-y-4" data-id="element-425" data-mp="1qc6qtfrckag3">
            <Button onClick={handleWhatsApp} size="lg" className="w-full text-base sm:text-lg font-semibold h-14 sm:h-16 !bg-[#25D366] hover:!bg-[#20bd5a] text-white shadow-md hover:shadow-lg transition-all duration-300 border-none" leftIcon={<MessageCircle className="w-6 h-6" data-id="element-427" data-mp="hyxji25wk0ei" />} data-id="element-426" data-mp="r0etr3wmp7va">
              Chatear por WhatsApp
            </Button>

            <p className="text-xs text-gray-400" data-id="element-428" data-mp="d042w0vbjta4">
              Respuesta rápida garantizada
            </p>

            <div className="pt-2" data-id="element-429" data-mp="83dqpommxhtz"></div>
          </div>
        </div>
      </div>

      {/* Footer minimal */}
      <div className="mt-8 text-center text-gray-400 text-xs sm:text-sm px-4" data-id="element-430" data-mp="39svg4cff1yh">
        &copy; {new Date().getFullYear()} Info Commerce AI Bootcamp. Todos los
        derechos reservados.
      </div>
    </div>;
}